import { Tools } from './tools';

export default function ToolsPage() {
  return <Tools />;
}
